<script lang="ts">
  interface Props {
    header?: import("svelte").Snippet;
    children?: import("svelte").Snippet;
  }

  let { header, children }: Props = $props();
  let expanded: boolean = $state(false);
</script>

<div
  class="my-2 -mx-3 border-Neutral200 focus-within:border-Violet700 bg-Neutral200 m-auto rounded-md"
>
  <button
    onclick={() => (expanded = !expanded)}
    type="button"
    aria-expanded={expanded}
    class="hover:underline text-left py-1 min-h-40 w-full pr-4 flex items-center cursor-pointer text-L text-bold overflow-visible text-Violet700 align-middle outline-none focus:outline-none appearance-none"
  >
    <span class="text-Red400 flex-shrink-0 {expanded ? 'minus' : 'plus'}"></span>
    {@render header?.()}
  </button>
  <div
    class=" transition-maxHeight overflow-hidden {expanded
      ? ' max-h-screen duration-500'
      : 'max-h-0 duration-150'}"
  >
    <div class="px-4 pb-4 pt-1">
      {@render children?.()}
    </div>
  </div>
</div>
